<template>
    <div class="text-container">
        <div class="title">ソフトウェアライセンスおよびサービス契約</div>
        <div class="subtitle">【重要なお知らせ】</div>
        <div class="text">
			[Guangzhou ixcam IoT Technology Co., Ltd.] (以下、「ixcam」といいます) は、ユーザーに対し、この「ソフトウェア ライセンスおよびサービス契約」(以下、「本契約」といいます) をよく読み、完全に理解するよう注意を促します。 ユーザーは、本契約の条項、特に ix cam の責任、紛争解決、および法的適用を免除または制限する条項を注意深く読み、完全に理解する必要があります。 責任を除外または制限する条項は太字でマークされており、注意深く読む必要があります。 注意深くお読みになり、本契約に同意するか同意しないかを選択してください (未成年者は法的保護者と一緒に読んでください)。 このソフトウェアのダウンロード、インストール、使用、アカウント取得およびログインは、本契約に同意し、本契約の条項に拘束されることに同意したものとみなされます。
        </div>
        <div class="text">
			ix cam は本契約を修正する権利を有し、更新された契約条件は公式 Web サイトまたはソフトウェア上で公開され、公開日から発効します。 ユーザーはソフトウェアを再ダウンロードしてインストールしたり、Web サイトで最新版の契約条件を確認したりできます。 ix camが本規約を変更した後、ユーザーが変更後の規約に同意しない場合は、ix camが提供する「ix cam」ソフトウェアおよびサービスの継続利用を直ちに停止してください。 ix cam が提供する変更された契約は受諾されたものとみなされます。
        </div>
        <div class="title">一、総則</div>
        <div class="text">
            1.1. 本契約は、ユーザーによるix cam「ix cam」ソフトウェア（以下「ix cam」）のダウンロード、インストールおよび使用に関して、お客様（以下「ユーザー」といいます）とix camおよびその運営パートナー（以下「パートナー」といいます）との間で締結されます。以下「ix cam」）「本ソフトウェア」）およびix cam関連サービスの利用契約を締結します。
        </div>
        <div class="text">
            1.2. 本ソフトウェアおよびサービスは、モバイルスマート端末を含むがこれに限定されないデバイスにインストールされ、スマート端末の利用者にスマート製品のバインドおよび操作な​​どのサービスを提供する、ix camが提供するソフトウェアおよびサービスです。
        </div>
        <div class="text">
            1.3. 本ソフトウェアおよびサービスの所有権および運営権はix camに帰属します。
        </div>
        <div class="title">二、ソフトウェア認証の範囲</div>
        <div class="text">
            2.1. ix cam は、このソフトウェアの個人的、譲渡不可、サブライセンス不可、および非独占的なライセンスをユーザーに付与します。
        </div>
        <div class="text">
            2.2. ユーザーは、非営利目的で本ソフトウェアを 1 台の携帯端末にインストール、使用、表示、実行することができます。 ただし、ユーザーは、本ソフトウェアを商用目的でインストール、使用、または実行することはできず、また、本ソフトウェアまたは本ソフトウェアの動作中に端末のメモリに解放されたデータをコピーまたは複製することもできません。ソフトウェアの動作中のクライアントとサーバー間の対話データとして、プラグイン、プラグイン、または未承認のサードパーティ ツールの使用を含むがこれらに限定されない、派生著作物の変更、修正、マウントおよび実行、または作成。ソフトウェアおよび関連システムにアクセスするためのサービス。 ソフトウェアのプレインストールやバンドルなど、商用販売、コピー、配布を行う必要がある場合は、ix cam から書面による承認と許可を取得する必要があります。
        </div>
        <div class="text">
            2.3. ユーザーは、ix cam の明示的な許可がない限り、セットトップ ボックス、ゲーム機、テレビ、DVD プレーヤーなどの他の端末デバイスにこのソフトウェアをインストールすることはできません。
        </div>
        <div class="text">
            2.4. ユーザーは、バックアップ目的でのみ、ソフトウェアおよびサービスを使用する目的でソフトウェアのコピーを1つ作成することができます。バックアップコピーには、元のソフトウェアに含まれているすべての著作権情報が含まれている必要があります。
        </div>
        <div class="text">
            2.5. 本契約で明示的に許可されている場合を除き、ix cam はユーザーにその他の権利を許可しません。ユーザーが他の権利を使用する場合は、ix cam から追加の書面による同意を取得する必要があります。
        </div>
        <div class="title">三、ソフトウェアの取得、インストール、およびアップグレード</div>
        <div class="text">
            3.1. ユーザーは、ix camの指定ウェブサイトまたは指定方法に従って本ソフトウェア製品をダウンロードし、インストールする必要があります。 携帯端末が不正プログラムに感染し、利用者のデータを破壊したり、個人情報を取得したりすることを防ぐため、指定以外のサイトから本ソフトウェアをダウンロードしないようご注意ください。 ユーザーがix camが認可していない第三者から本ソフトウェアまたは本ソフトウェアと同名のインストールプログラムを入手した場合、ix camはソフトウェアの正常な使用を保証できず、ユーザーに生じたいかなる損害についても責任を負いません。
        </div>
        <div class="text">
            3.2.ユーザーは、インストールされている端末デバイスに一致するソフトウェアのバージョンを選択する必要があります。そうでない場合、ソフトウェアの問題、デバイスの問題、またはソフトウェアとデバイスモデルの不一致によって引き起こされる損傷はユーザーが負担するものとします。
        </div>
        <div class="text">
            3.3. ユーザーエクスペリエンスを向上させ、サービス内容を改善するために、ix cam は、本ソフトウェアの交換、修正、およびアップグレードバージョンを随時提供する権利を有し、また、交換、修正、変更に対して料金を請求する権利を有します。またはアップグレードしますが、課金については事前にお客様の同意を得るものとします。 このソフトウェアは、ユーザーが使用するソフトウェアのバージョンに応じて、デフォルトでユーザーに対して「アップグレード プロンプト」機能を有効にするオプションを提供します。 ソフトウェアの新しいバージョンがリリースされた後、ix cam はソフトウェアの古いバージョンが引き続き利用可能であることを保証しません。
        </div>
        <div class="title">四、規範の使用</div>
        <div class="text">
            4.1.ユーザーは、法律および本契約を遵守することを前提として、本契約に従ってソフトウェアおよびサービスを使用することができ、ユーザーは以下の行為を行わないものとします。
        </div>
        <div class="text">
            •	4.1.1.このソフトウェアおよびその他のコピーのすべての著作権情報を削除し、知的財産権を保護するためにこのソフトウェアによって設定された技術的手段を変更、削除、または回避します。
        </div>
        <div class="text">
            •	4.1.2.ソフトウェアの逆アセンブル、逆コンパイル、またはその他の方法でソフトウェアのソースコードを取得しようとするなど、ソフトウェアのリバースエンジニアリング。
        </div>
        <div class="text">
            •	4.1.3.ソフトウェアの実行中の指示およびデータの変更または改ざん、ソフトウェアの機能または操作効果の追加、削除、変更、または上記の目的で使用されるソフトウェアおよび方法の操作または配布により、商業目的であるかどうかにかかわらず、これらの行為に関係なく、一般の人々。
        </div>
        <div class="text">
            •	4.1.4. このソフトウェアを使用して、ネットワークセキュリティを危険にさらす行為を実行します。これには、許可されていないデータの使用、許可されていないサーバー/アカウントの入力、保存されている情報の変更または増加、弱点の調査、スキャン、テストが含まれます。ソフトウェアのシステムまたはネットワークを許可なく実行する、またはネットワークセキュリティを損なうその他の行為を実行する、ソフトウェアシステムまたはWebサイトの通常の動作を妨害または破壊しようとする、悪意のあるプログラムまたはウイルスを意図的に拡散する、および通常のネットワーク情報サービスを妨害および妨害するその他の動作; TCP / IPパケット名または部分名を偽造します。
        </div>
        <div class="text">
            • 4.1.5. ユーザーは、ix cam が開発、認可、または認識していないサードパーティの互換ソフトウェアまたはシステムを通じてこのソフトウェアおよびサービスにログインまたは使用するか、上記のツールを作成、公開、または配布します。
        </div>
        <div class="text">
            • 4.1.6. ix cam の書面による同意がない場合、ソフトウェアおよびその情報に対するユーザーの許可されていない行為には、使用、レンタル、貸与、コピー、変更、リンク、再版、組み立て、公開が含まれますが、これらに限定されません。 、ミラーサイトの公開および作成、関連する派生製品、著作物、サービス、プラグイン、プラグイン、互換性、相互接続などを開発するために本ソフトウェアを不正に使用すること。
        </div>
        <div class="text">
            •	4.1.7. このソフトウェアを使用して、地域の法律および規制に違反するコンテンツを公開、送信、配布、および保存します。
        </div>
        <div class="text">
            •	4.1.8.このソフトウェアを使用して、他者の知的財産権、企業秘密、およびその他の法的権利を侵害するコンテンツを公開、送信、配布、および保存します。
        </div>
        <div class="text">
            •	4.1.9. このソフトウェアを使用して、広告情報とスパムをバッチで公開、送信、および配布します。
        </div>
        <div class="text">
            • 4.1.10. 他の者が、違法な方法、違法な目的、または本契約で許可されている使用に反する方法で、ix cam が提供する本ソフトウェアおよびその他のサービスを使用する。
        </div>
        <div class="text">
            4.2. 情報リリース仕様
        </div>
        <div class="text">
            •	4.2.1．このソフトウェアを使用して、オリジナルの意見、データ、テキスト、情報、ユーザー名、写真、写真、個人情報、オーディオ、ビデオファイル、リンク、およびオリジナルであるか、表現する権利があるその他の情報コンテンツを表現できます。アップロードした情報または法的に許可された情報の知的財産権を所有していること、およびソフトウェアとサービスの使用が第三者の正当な権利と利益を侵害していないことを確認する必要があります。
        </div>
        <div class="text">
            •	4.2.2．このソフトウェアの使用は、地域の法律および規制の対象となります。
        </div>
        <div class="text">
            4.2.3．このソフトウェアを使用する場合、以下を含むがこれらに限定されない以下の行為に従事するためにこのソフトウェアを使用してはなりません。
        </div>
        <div class="text">
            4.2.3.1.地域の法律および規制に違反するコンテンツを作成、複製、公開、配布、および保存する。
        </div>
        <div class="text">
            4.2.3.2.評判、肖像画、知的財産、企業秘密など、他者の法的権利を侵害するコンテンツを公開、送信、配布、および保存すること。
        </div>
        <div class="text">
            4.2.3.3.他人を誤解させたり欺いたりするために、事実を偽造したり、真実を隠したりする。
        </div>
        <div class="text">
            4.2.3.4広告情報およびスパムを公開、送信、および配布する。
        </div>
        <div class="text">
            4.2.3.5.地域の法律および規制に違反するその他の行為に従事する。
        </div>
        <div class="text">
            4.2.4. ix cam の許可がない限り、このソフトウェアで広告の掲載や商品の販売などの商業活動を行うことはできません。
        </div>
        <div class="title">4.3.あなたは次のことを理解し、同意します:</div>
        <div class="text">
            • 4.3.1. ix camは、ユーザーが上記の利用規定に違反している疑いがあるかどうかを判断し、その判断結果に基づいて、利用ライセンスの停止または終了、または本規約に従って講じることができるその他の制限措置を講じます。 ;
        </div>
        <div class="text">
            • 4.3.2. ix cam は、違法の疑いがある、または他者の法的権利を侵害している、または本契約に違反している疑いのあるライセンス ソフトウェアを使用する場合、ユーザーが投稿した情報を直接削除します。
        </div>
        <div class="text">
			• 4.3.3. ユーザーによる上記の使用規則の違反が第三者に損害を与えた場合、ユーザーは自らの名において独自に法的責任を負う必要があり、ix cam が損失や追加費用から保護されるようにする必要があります。
        </div>
        <div class="text">
            • 4.3.4。 ユーザーが関連する法的規定または契約に違反し、ix camに損失を与えた場合、第三者からの請求の対象となった場合、または行政当局から処罰を受けた場合、ユーザーは、結果として生じた損失および/または費用について、ix camに合理的な費用を含めて補償するものとします。弁護士費用、捜査、証拠収集費用。
        </div>
        <div class="title">五、サービスのリスクと免責事項</div>
        <div class="text">
            5.1. ユーザーは、インターネットにアクセスし、電気通信の付加価値サービスに必要な機器を使用するために、自分のモバイル端末機器を装備し、インターネットにアクセスするために、または3番目に個人のモバイル端末機器によって請求される通信料金、情報料金などを負担する必要があります。当事者（電気通信または移動体通信プロバイダーを含むがこれらに限定されない）関連料金。電気通信の付加価値サービスが含まれる場合は、関連する料金を電気通信の付加価値サービスプロバイダーに確認することをお勧めします。
        </div>
        <div class="text">
			5.2. ix camおよびそのパートナーは、通信回線の障害、技術的問題、ネットワーク、携帯端末機器の障害、システムの不安定、その他の不可抗力によりユーザーが被った損害については一切責任を負いません。
        </div>
        <div class="text">
            5.3. このソフトウェアは、ほとんどのインターネットソフトウェアと同様に、ユーザーの理由、ネットワークサービスの品質、社会環境、その他の要因の影響を受け、他者によるユーザー情報の使用など、さまざまなセキュリティ問題によって妨害される可能性があります。ユーザーや訪問した他のウェブサイトによってダウンロードおよびインストールされた他のソフトウェアには、ユーザーの端末機器の情報やデータのセキュリティを脅かし、このソフトウェアの通常の使用に影響を与える「トロイの木馬」などのウイルスが含まれています。ユーザーは、情報セキュリティとユーザーデータ保護の意識を強化し、紛失や嫌がらせを避けるためにパスワード保護の強化に注意を払う必要があります。
        </div>
        <div class="text">
            5.4. ユーザーがこのソフトウェアを使用する場合、または特定のサービスを提供するために ix cam を必要とする場合、ソフトウェアはユーザーの使用またはアクセスをサポートするためにサードパーティのシステムまたはサードパーティのソフトウェアを呼び出すことがあります。その使用またはアクセスの結果は、サードパーティ、および ix cam は、サードパーティのシステムまたはサードパーティ ソフトウェアのサポートを通じて達成された結果の安全性、精度、有効性、およびその他の不確実なリスクから生じる紛争や損害について、ix cam が一切の責任を負わないことを保証しません。
        </div>
        <div class="text">
            5.5. ix cam は、事業開発および調整における会社の自主性を保護するために、ix cam がユーザーに通知することなくいつでもサービスを変更または中断する権利を有することをユーザーに特に通知します。サービスの中断はユーザーまたは第三者の責任となります。
        </div>
        <div class="text">
            5.6. 法律や規制で別段の定めがない限り、当社はソフトウェアおよび関連する技術および情報が安全、効果的、正確かつ信頼できるものであることを保証するために最善を尽くしますが、既存の技術には限界があるため、ユーザーはそれを理解しています。これは保証できません。
        </div>
        <div class="text">
            5.7. 以下の状況のいずれかに起因または関連する、利益の損失、データの損失、事業の中断による損害、またはその他の商業的損害を含むがこれらに限定されない、人身傷害または偶発的な間接的な経済的損害。損失はユーザーが負担するものとします：
        </div>
        <div class="text">
            •	5.7.1.ライセンス対象ソフトウェアの使用または使用の失敗；
        </div>
        <div class="text">
            •	5.7.2.第三者によるソフトウェアの不正使用またはユーザーデータの変更；
        </div>
        <div class="text">
            •	5.7.3.ソフトウェアを使用するユーザーの行動から生じる費用と損失；
        </div>
        <div class="text">
            •	5.7.4.ユーザーによるソフトウェアの誤解；
        </div>
        <div class="text">
            • 5.7.5. ix cam によって引き起こされないその他のソフトウェア関連の損失。
        </div>
        <div class="text">
            5.8. 誤解または騙されたためにソフトウェアを介してソフトウェアのユーザーと他のユーザーとの間の行動によって引き起こされた、または引き起こされる可能性のある人的または経済的傷害または損失は、法律に従って障害のある当事者が負担するものとします。
        </div>
        <div class="title">六、知的財産声明</div>
        <div class="text">
            6.1. ix cam はこのソフトウェアの知的財産権の所有者です。 本ソフトウェアのすべての著作権、商標、特許、企業秘密およびその他の知的財産権、および本ソフトウェアに関連するすべての情報コンテンツ（テキスト、画像、音声、ビデオ、チャート、インターフェイス デザイン、レイアウト フレームワーク、関連データや電子文書など）は、現地の法律および規制および対応する国際条約によって保護されており、ix cam は上記の知的財産権を享受します。
        </div>
        <div class="text">
            6.2 ix cam の書面による同意がない限り、ユーザーは上記の知的財産権を自ら実施、利用、譲渡してはなりません。また、営利目的または非営利目的で第三者に許可することはできません。ix cam は、上記について法的責任を追及する権利を留保します。行為。
        </div>
        <div class="title">七、契約の変更</div>
        <div class="text">
            7.1. ix cam は、必要に応じて本契約の条件を変更する権利を有し、契約の条件が変更されると、関連するページで変更された契約の条件が発表されます。 変更内容に同意できない場合は、ユーザー自らが本サービスを解約するものとします。 ユーザーがサービスの利用を継続した場合、規約の変更に同意したものとみなされます。
        </div>
        <div class="text">
            7.2. ix camおよびそのパートナー企業は、必要に応じて提供される充電サービス、充電規格、充電方法、サービス料金およびサービス条件を修正または変更する権利を有します。 ix camがサービスを提供する場合、現在または将来、一部のサービスの利用者から一定の料金を徴収する場合があります。利用者がかかる料金の支払いを拒否した場合、課金開始後は当該サービスを継続して利用することができなくなります。 ix cam およびパートナー企業は、関連する変更または変更を電子メールまたはその他の手段でユーザーに通知するために最善を尽くします。
        </div>
        <div class="title">八、適用法および紛争解決</div>
        <div class="text">
            8.1. 本契約の条件の有効性と解釈は、中華人民共和国本土の法律に準拠するものとします。関連する法的規定がない場合は、国際的な商慣行および/または商慣行が参照されます。
        </div>
        <div class="text">
            8.2. この協定が署名されている場所は、北京の海淀区です。
        </div>
        <div class="text">
            8.3． ユーザーとix camは、本サービスに起因するすべての紛争は交渉によって解決されるべきであることに同意します。交渉が不成立の場合、いずれかの当事者は、本契約が締結された場所を管轄する裁判所に訴訟を起こすことができます。
        </div>
        <div class="title">九、その他</div>
        <div class="text">
            9.1. ユーザーが本ソフトウェアの特定のサービスを利用する場合、本サービスは、別途契約、関連するビジネスルール等（以下、総称して「別途規約」といいます）を締結する場合があります。関連する個別の契約。
        </div>
        <div class="text">
            9.2. 本契約の発効日は2018年3月13日です。
        </div>
        <div class="text">
            9.3. 本契約のすべての条項のタイトルは、読みやすくするためのものであり、それ自体には実際の意味はなく、本契約の意味の解釈の基礎として使用することはできません。
        </div>
        <div class="text">
            9.4. 何らかの理由で、本契約の条件は部分的に無効または執行不能であり、残りの条件は引き続き有効であり、両当事者を拘束します。
        </div>
        <div class="text">
            ix cam
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style lang="less" scoped>
    .text-container {
        padding: 0 50px;
        .title {
            font-size: 30px;
            margin: 15px 0;
            font-weight: 900;
        }
        .subtitle {
            font-size: 25px;
            margin: 10px 0;
            font-weight: 600;
        }
    }
</style>